"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRange = void 0;
var _Range = require("./Range");
// TODO: in v9, move styled() from Range.jsx to here
var StyledRange = _Range.Range;
exports.StyledRange = StyledRange;